const CONSENT_KEY = 'byn_mina_sidor_cookie_consent'
// 12 months in seconds
const CONSENT_MAX_AGE = 60 * 60 * 24 * 365
const SCRIPT_URL = process.env.VUE_APP_HOTJAR_SCRIPT_URL ?? ''
const SCRIPT_ID = 'contentsquare-tracking'

export const setConsent = function(value) {
  document.cookie = `${CONSENT_KEY}=${value}; max-age=${CONSENT_MAX_AGE}; path=/; SameSite=Lax`
}

export const getConsent = function() {
  const match = document.cookie.match(new RegExp('(?:^|; )' + CONSENT_KEY + '=([^;]*)'))
  return match ? decodeURIComponent(match[1]) : null
}

export const hasConsentChoice = function() {
  return getConsent() !== null
}

export const loadConsentScript = function() {
  const elementScriptId = document.getElementById(SCRIPT_ID)
  
  if ( elementScriptId || !SCRIPT_URL ) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = SCRIPT_URL
  script.async = true
  document.head.appendChild(script)
}

export const unloadConsentScript = function() {
  const script = document.getElementById(SCRIPT_ID)
  if (script) script.remove()
}